export function isLocalStorageAvailable() {
  if (!window) {
    return false;
  }
  return Boolean(window.localStorage);
}
